function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';

var ButtonPanel = function (_React$Component) {
  _inherits(ButtonPanel, _React$Component);

  function ButtonPanel() {
    _classCallCheck(this, ButtonPanel);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  ButtonPanel.prototype.onClick = function onClick(event) {
    var target = event.target;
    target.classList.remove('clicked');
    setTimeout(function () {
      target.classList.add('clicked');
    }, 0);
    this.props.onClick(target.dataset.value);
  };

  ButtonPanel.prototype.componentDidMount = function componentDidMount() {
    var buttons = document.querySelectorAll('.react-calc button');
    buttons = [].slice.call(buttons);
    var keyMapping = {};
    buttons.forEach(function (button) {
      keyMapping[button.dataset.code] = button;
    });
    this.props.onLoad(keyMapping);
  };

  ButtonPanel.prototype.render = function render() {
    return React.createElement('div', {
      className: 'react-calc button-panel row'
    }, React.createElement('div', {
      className: 's3 column'
    }, React.createElement('div', {
      className: 's1 row'
    }, React.createElement('button', {
      className: 'button s2',
      'data-code': '67',
      'data-value': 'c',
      onClick: this.onClick
    }, 'C'), React.createElement('button', {
      className: 'button s1',
      'data-code': '8',
      'data-value': 'back',
      onClick: this.onClick
    }, "\u2190")), React.createElement('div', {
      className: 's1 row'
    }, React.createElement('button', {
      className: 'button s1',
      'data-code': '55',
      'data-value': '7',
      onClick: this.onClick
    }, '7'), React.createElement('button', {
      className: 'button s1',
      'data-code': '56',
      'data-value': '8',
      onClick: this.onClick
    }, '8'), React.createElement('button', {
      className: 'button s1',
      'data-code': '57',
      'data-value': '9',
      onClick: this.onClick
    }, '9')), React.createElement('div', {
      className: 's1 row'
    }, React.createElement('button', {
      className: 'button s1',
      'data-code': '52',
      'data-value': '4',
      onClick: this.onClick
    }, '4'), React.createElement('button', {
      className: 'button s1',
      'data-code': '53',
      'data-value': '5',
      onClick: this.onClick
    }, '5'), React.createElement('button', {
      className: 'button s1',
      'data-code': '54',
      'data-value': '6',
      onClick: this.onClick
    }, '6')), React.createElement('div', {
      className: 's1 row'
    }, React.createElement('button', {
      className: 'button s1',
      'data-code': '49',
      'data-value': '1',
      onClick: this.onClick
    }, '1'), React.createElement('button', {
      className: 'button s1',
      'data-code': '50',
      'data-value': '2',
      onClick: this.onClick
    }, '2'), React.createElement('button', {
      className: 'button s1',
      'data-code': '51',
      'data-value': '3',
      onClick: this.onClick
    }, '3')), React.createElement('div', {
      className: 's1 row'
    }, React.createElement('button', {
      className: 'button s2',
      'data-code': '48',
      'data-value': '0',
      onClick: this.onClick
    }, '0'), React.createElement('button', {
      className: 'button s1',
      'data-code': '190',
      'data-value': '.',
      onClick: this.onClick
    }, '.'))), React.createElement('div', {
      className: 's1 column'
    }, React.createElement('button', {
      className: 'last button s1',
      'data-code': '191',
      'data-value': '/',
      onClick: this.onClick
    }, '\xF7'), React.createElement('button', {
      className: 'last button s1',
      'data-code': 'shift+56',
      'data-value': '*',
      onClick: this.onClick
    }, '\xD7'), React.createElement('button', {
      className: 'last button s1',
      'data-code': '189',
      'data-value': '-',
      onClick: this.onClick
    }, '-'), React.createElement('button', {
      className: 'last button s1',
      'data-code': 'shift+187',
      'data-value': '+',
      onClick: this.onClick
    }, '+'), React.createElement('button', {
      className: 'last button s1 button-equal',
      'data-code': '13',
      'data-value': '=',
      onClick: this.onClick
    }, '=')));
  };

  return ButtonPanel;
}(React.Component);

export { ButtonPanel as default };